/* Loomexra Shopify Theme JS
   Handles: mobile drawer, announcement bar rotation, wishlist (localStorage),
   AJAX add-to-cart, cart drawer, quantity steppers, quick view modal.
*/
(function () {
  const qs = (sel, ctx) => (ctx || document).querySelector(sel);
  const qsa = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  document.addEventListener('DOMContentLoaded', () => {
    if (window.lucide) lucide.createIcons();
    setupAnnouncementBar();
    setupMobileDrawer();
    setupStickyHeader();
    setupWishlist();
    setupAddToCart();
    setupCartDrawer();
    setupCartPageQty();
    setupQuickView();
    setupWishlistDrawer();
    setupLoginForms();
    updateCartCount();
  });

  /* ---------------- Announcement bar rotation ---------------- */
  function setupAnnouncementBar() {
    const wrap = qs('#announcement-text');
    if (!wrap) return;
    const msgs = qsa('.announcement-msg', wrap);
    if (msgs.length < 2) return;
    const seconds = parseInt(wrap.dataset.autoplay || '4', 10);
    let idx = 0;
    setInterval(() => {
      msgs[idx].classList.remove('is-active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('is-active');
    }, seconds * 1000);
  }

  /* ---------------- Mobile drawer ---------------- */
  function setupMobileDrawer() {
    const drawer = qs('#mobile-drawer');
    const openBtn = qs('#hamburger-btn');
    const closeBtn = qs('#drawer-close');
    const backdrop = qs('#drawer-backdrop');
    if (!drawer || !openBtn) return;
    openBtn.addEventListener('click', () => drawer.classList.add('open'));
    closeBtn && closeBtn.addEventListener('click', () => drawer.classList.remove('open'));
    backdrop && backdrop.addEventListener('click', () => drawer.classList.remove('open'));
  }

  function setupStickyHeader() {
    const header = qs('#site-header');
    if (!header) return;
    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 40) header.classList.add('is-sticky');
      else header.classList.remove('is-sticky');
      lastY = window.scrollY;
    });
  }

  /* ---------------- Wishlist (client-side, localStorage) ---------------- */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('loomexra_wishlist') || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem('loomexra_wishlist', JSON.stringify(list));
    updateWishlistBadge();
  }
  function updateWishlistBadge() {
    const badge = qs('#wishlist-count');
    if (!badge) return;
    const count = getWishlist().length;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }
  function setupWishlist() {
    updateWishlistBadge();
    const stored = getWishlist();
    qsa('[data-wish]').forEach(btn => {
      if (stored.includes(btn.dataset.wish)) btn.classList.add('active');
    });
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wish], [data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.wish || btn.dataset.productId;
      let list = getWishlist();
      if (list.includes(id)) {
        list = list.filter(x => x !== id);
        btn.classList.remove('active');
      } else {
        list.push(id);
        btn.classList.add('active');
        showToast('Added to wishlist');
      }
      saveWishlist(list);
      if (qs('#wishlist-drawer.open')) renderWishlistDrawer();
    });

    const openBtn = qs('#wishlist-btn');
    if (openBtn) openBtn.addEventListener('click', openWishlistDrawer);
  }

  function setupWishlistDrawer() {
    const drawer = qs('#wishlist-drawer');
    if (!drawer) return;
    const closeBtn = qs('#wishlist-drawer-close');
    const backdrop = qs('#wishlist-drawer-backdrop');
    closeBtn && closeBtn.addEventListener('click', closeWishlistDrawer);
    backdrop && backdrop.addEventListener('click', closeWishlistDrawer);
  }
  function openWishlistDrawer() {
    const drawer = qs('#wishlist-drawer');
    if (!drawer) return;
    renderWishlistDrawer();
    drawer.classList.add('open');
  }
  function closeWishlistDrawer() {
    const drawer = qs('#wishlist-drawer');
    if (drawer) drawer.classList.remove('open');
  }
  function renderWishlistDrawer() {
    const body = qs('#wishlist-drawer-body');
    if (!body) return;
    const handles = getWishlist();
    if (handles.length === 0) {
      body.innerHTML = '<div class="cart-drawer-empty">Nothing saved yet. Tap the heart on any product to add it here.</div>';
      return;
    }
    body.innerHTML = '<div class="cart-drawer-empty">Loading...</div>';
    Promise.all(handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))
      .then(products => {
        const valid = products.filter(Boolean);
        if (valid.length === 0) {
          body.innerHTML = '<div class="cart-drawer-empty">Nothing saved yet.</div>';
          return;
        }
        body.innerHTML = valid.map(p => `
          <div class="cart-drawer-line">
            <img src="${p.featured_image}" alt="${p.title}">
            <div>
              <a href="${p.url}" class="cart-drawer-line-title">${p.title}</a>
              <div class="cart-drawer-line-variant">${formatMoney(p.price)}</div>
              <div style="display:flex;gap:8px;margin-top:6px;">
                <button class="btn btn-dark" style="padding:6px 12px;font-size:0.7rem;" data-wish-add-cart="${p.variants[0].id}">Add to cart</button>
                <button class="btn btn-outline" style="padding:6px 12px;font-size:0.7rem;" data-wish-remove="${p.handle}">Remove</button>
              </div>
            </div>
          </div>
        `).join('');
      });
  }
  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-wish-remove]');
    if (removeBtn) {
      const list = getWishlist().filter(h => h !== removeBtn.dataset.wishRemove);
      saveWishlist(list);
      renderWishlistDrawer();
      return;
    }
    const addBtn = e.target.closest('[data-wish-add-cart]');
    if (addBtn) {
      addToCart(addBtn.dataset.wishAddCart, 1);
    }
  });

  /* ---------------- Add to cart (AJAX) ---------------- */
  function setupAddToCart() {
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest('.atc-btn, .product-quick-add');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (variantId) {
        addToCart(variantId, 1);
      } else if (btn.dataset.productHandle) {
        fetch(`/products/${btn.dataset.productHandle}.js`)
          .then(r => r.json())
          .then(product => {
            const variant = product.variants.find(v => v.available) || product.variants[0];
            addToCart(variant.id, 1);
          })
          .catch(() => showToast('Unable to add to cart'));
      }
    });

    const productForm = qs('#ProductForm');
    if (productForm) {
      productForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(productForm);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(r => r.json())
          .then(() => { showToast('Added to cart'); updateCartCount(); openCartDrawer(); })
          .catch(() => showToast('Unable to add to cart'));
      });
    }
  }

  function addToCart(id, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity })
    })
      .then(r => r.json())
      .then(() => { showToast('Added to cart'); updateCartCount(); openCartDrawer(); })
      .catch(() => showToast('Unable to add to cart'));
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = qs('#cart-count');
        if (badge) badge.textContent = cart.item_count;
        const subtotal = qs('#cart-drawer-subtotal-amount');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  }

  /* ---------------- Cart drawer ---------------- */
  function setupCartDrawer() {
    const drawer = qs('#cart-drawer');
    if (!drawer) return;
    const closeBtn = qs('#cart-drawer-close');
    const backdrop = qs('#cart-drawer-backdrop');
    closeBtn && closeBtn.addEventListener('click', closeCartDrawer);
    backdrop && backdrop.addEventListener('click', closeCartDrawer);
    const cartIconBtn = qs('#cart-icon-btn');
    if (cartIconBtn && qs('.cart-drawer-panel')) {
      cartIconBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    }
  }

  function openCartDrawer() {
    const drawer = qs('#cart-drawer');
    if (!drawer) return;
    renderCartDrawer();
    drawer.classList.add('open');
  }
  function closeCartDrawer() {
    const drawer = qs('#cart-drawer');
    if (drawer) drawer.classList.remove('open');
  }
  function renderCartDrawer() {
    const body = qs('#cart-drawer-body');
    if (!body) return;
    fetch('/cart.js').then(r => r.json()).then(cart => {
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
        return;
      }
      body.innerHTML = cart.items.map(item => `
        <div class="cart-drawer-line">
          <img src="${item.image}" alt="${item.product_title}">
          <div>
            <div class="cart-drawer-line-title">${item.product_title}</div>
            ${item.variant_title ? `<div class="cart-drawer-line-variant">${item.variant_title}</div>` : ''}
            <div class="cart-drawer-line-variant">Qty: ${item.quantity}</div>
          </div>
          <div>${formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');
      const subtotal = qs('#cart-drawer-subtotal-amount');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    });
  }

  /* ---------------- Cart page quantity steppers ---------------- */
  function setupCartPageQty() {
    document.body.addEventListener('click', (e) => {
      const dec = e.target.closest('[data-qty-dec]');
      const inc = e.target.closest('[data-qty-inc]');
      if (!dec && !inc) return;
      const line = (dec || inc).dataset.qtyDec || (dec || inc).dataset.qtyInc;
      const valEl = qs(`[data-qty-val="${line}"]`);
      const inputEl = qs(`[data-qty-input="${line}"]`);
      if (!valEl) return;
      let val = parseInt(valEl.textContent, 10) || 1;
      val = dec ? Math.max(0, val - 1) : val + 1;
      valEl.textContent = val;
      if (inputEl) inputEl.value = val;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: val })
      }).then(() => { updateCartCount(); if (val === 0) window.location.reload(); });
    });
  }

  /* ---------------- Quick view modal (uses existing #qv-overlay markup if present) ---------------- */
  function setupQuickView() {
    const overlay = qs('#qv-overlay');
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qv]');
      if (!btn || !overlay) return;
      e.preventDefault();
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      fetch(`/products/${handle}.js`).then(r => r.json()).then(product => {
        qs('#qv-img', overlay).src = product.featured_image;
        qs('#qv-name', overlay).textContent = product.title;
        qs('#qv-price', overlay).textContent = formatMoney(product.price);
        qs('#qv-desc', overlay).textContent = (product.description || '').replace(/<[^>]*>/g, '').slice(0, 200);
        const atc = qs('#qv-atc', overlay);
        if (atc) atc.dataset.variantId = product.variants[0].id;
        overlay.classList.add('open');
      });
    });
    if (overlay) {
      overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.classList.remove('open'); });
      const closeBtn = qs('#qv-close', overlay);
      closeBtn && closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
      const atcBtn = qs('#qv-atc', overlay);
      atcBtn && atcBtn.addEventListener('click', () => {
        if (atcBtn.dataset.variantId) addToCart(atcBtn.dataset.variantId, 1);
        overlay.classList.remove('open');
      });
    }
  }

  /* ---------------- Login / Register page niceties ---------------- */
  function setupLoginForms() {
    const recoverLink = qs('#RecoverPasswordLink');
    const recoverForm = qs('#RecoverPasswordForm');
    const loginForm = qs('#CustomerLoginForm');
    if (recoverLink && recoverForm && loginForm) {
      recoverLink.addEventListener('click', (e) => {
        e.preventDefault();
        loginForm.style.display = 'none';
        recoverForm.style.display = 'block';
      });
      const cancelLink = qs('#CancelRecoverPasswordLink');
      cancelLink && cancelLink.addEventListener('click', (e) => {
        e.preventDefault();
        recoverForm.style.display = 'none';
        loginForm.style.display = 'block';
      });
    }
  }

  /* ---------------- Toast ---------------- */
  function showToast(msg) {
    const container = qs('#toast-container');
    if (!container) return;
    const t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    t.style.cssText = 'background:var(--brand-dark);color:#fff;padding:10px 18px;border-radius:4px;font-size:0.85rem;box-shadow:0 4px 16px rgba(0,0,0,0.15);';
    container.appendChild(t);
    setTimeout(() => t.remove(), 2800);
  }

  window.LoomexraTheme = { showToast, addToCart, updateCartCount, openCartDrawer, closeCartDrawer };
})();
